"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainElementArraySchema = exports.ChainElementSchema = exports.DApiElementArraySchema = exports.DApiElementSchema = void 0;
const api_integrations_1 = require("@api3/api-integrations");
const promise_utils_1 = require("@api3/promise-utils");
const lodash_1 = require("lodash");
const z = __importStar(require("zod"));
const contracts_1 = require("@api3/contracts");
exports.DApiElementSchema = z
    .object({
    name: z.string(),
    metadata: z
        .object({
        prefix: z.enum(['$', ' ', '']),
        category: z.enum([
            'Commodities',
            'Cryptocurrency',
            'Equities',
            'Forex',
            'LST & LRT Exchange Rates',
            'Stablecoin',
        ]),
        description: z.string().optional(),
    })
        .strict(),
    providers: z.array(z.string()),
    stage: z.enum(['active', 'deprecated', 'surveying', 'retired']),
})
    .strict()
    .superRefine(({ name, metadata, providers, stage }, ctx) => {
    if (metadata.category === 'LST & LRT Exchange Rates' && stage !== 'retired') {
        // check LSD descriptions
        const goDescription = (0, promise_utils_1.goSync)(() => (0, api_integrations_1.generateDescriptionTextForLSD)(name));
        if (!goDescription.success) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: goDescription.error.message,
                path: ['metadata', 'description'],
            });
        }
        if (metadata.description !== goDescription.data) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `Description for dAPI '${name}' is missing or wrong.`,
                path: ['metadata', 'description'],
            });
        }
    }
    if (stage !== 'retired') {
        providers.forEach((provider, index) => {
            const providerData = api_integrations_1.apisData[provider];
            // make sure the provider exist in api-integrations
            if (!providerData) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `Provider '${provider}' does not exist in api-integrations.`,
                    path: ['providers', index],
                });
            }
            // make sure the provider supports the corresponding data feed
            if (providerData) {
                const supportedFeeds = Object.values(providerData.supportedFeedsInBatches).flat(2);
                if (!supportedFeeds.includes(name)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `Provider '${provider}' does not support data feed '${name}'.`,
                        path: ['providers', index],
                    });
                }
            }
        });
    }
    // check providers order
    const dapiProviders = providers.map((p) => p.toLocaleLowerCase());
    const sortedDapiProviders = [...dapiProviders].sort();
    if (!(0, lodash_1.isEqual)(dapiProviders, sortedDapiProviders)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `Providers are not sorted for dAPI '${name}'.`,
            path: ['providers'],
        });
    }
});
exports.DApiElementArraySchema = z.array(exports.DApiElementSchema).superRefine((dapis, ctx) => {
    // check dAPI order
    const dapiNames = dapis.map((d) => d.name.toLocaleLowerCase());
    const sortedDapiNames = [...dapiNames].sort();
    if (!(0, lodash_1.isEqual)(dapiNames, sortedDapiNames)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'dAPI names must be in alphabetical order.',
            path: ['name'],
        });
    }
});
exports.ChainElementSchema = z
    .object({
    alias: z.string(),
    stage: z.enum(['active', 'deprecated', 'surveying', 'retired']),
    id: z.string().optional(),
})
    .strict()
    .superRefine(({ alias, stage }, ctx) => {
    // Check if the chain exists in @api3/contracts
    const api3ChainAliases = contracts_1.CHAINS.map((c) => c.alias);
    // If the chain is retired, skip the check
    if (stage === 'retired') {
        return;
    }
    if (!api3ChainAliases.includes(alias)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `Chain '${alias}' does not exist in @api3/contracts package.`,
            path: ['alias'],
        });
    }
});
exports.ChainElementArraySchema = z.array(exports.ChainElementSchema).superRefine((chains, ctx) => {
    // Check chains order
    const chainAliases = chains.map((c) => c.alias.toLocaleLowerCase());
    const sortedChainAliases = [...chainAliases].sort();
    if (!(0, lodash_1.isEqual)(chainAliases, sortedChainAliases)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Chain aliases must be in alphabetical order.',
            path: ['alias'],
        });
    }
});
//# sourceMappingURL=types.js.map